var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component_prop.type,{tag:"component",attrs:{"prop_data":_vm.component_prop}})
}
var staticRenderFns = []

export { render, staticRenderFns }